import React, { useEffect, useRef, useState } from "react";

/* -------- framework elements -------- */
import { dictionary } from "../../utils/dictionary";
/* -------- ------- -------- */

/* -------- packages -------- */
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { 
  Container,
  Row,
  Col,
  Card,
  CardBody,
 } from "reactstrap";
import { toast, ToastContainer } from "react-toastify";
import { Link, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
/* -------- ------- -------- */

/* -------- components -------- */
import Loading from '../../components/ui/Loading';
import Tuiles from "../../components/ui/Projects/Tuiles";
import NewProjectModal from "../../components/ui/Modals/NewProjectModal";
import DashboardLayout from "../../components/layout/Dashboard";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { checkConfigurationsExpiredRequest, clearProjectErrors, clearProjectSuccess, fetchProjectsRequest, fetchUsersRequest } from "../../store/actions";
import { getProfileImage } from "../../utils/userTools";
import { getErrorMessage } from "../../utils/utils";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */


export default function Projects () {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const parameters = useSelector(state => state.Parameters);
  
  document.title = `${t('myProjects')} | ${parameters.appName}`; //meta title
  const {users} = useSelector(state => state.Users);
  const user = useSelector(state => state.Login.user);
  const userPref = user && typeof user.prefs === 'object' ? user.prefs : JSON.parse(user.prefs);


  const {projects, projectAdded, errorProject} = useSelector(state => state.Projects); // get projects from store

  const [imgSrc, setImgSrc] = useState(parameters.logoIcon); // set user image
  const [customerFilter, setCustomerFilter] = useState([]); // set user image
  
  
  
/* ------------------- profile image ------------------- */
  useEffect(() => {
    setImgSrc(getProfileImage(userPref, parameters.logoIcon)); // Suppose que les images sont nommées avatar_1.jpg, avatar_2.jpg, etc.
  }, [userPref]);

/* ------------------- ------------- ------------------- */


  const [customersNum, setCustomersNum] = useState(0);
  const [projectsNum, setProjectsNum] = useState(0);
  const [projectsOpen, setProjectsOpen] = useState(0);
  const [projectsClose, setProjectsClose] = useState(0);
  const [configsNum, setConfigsNum] = useState(0);
  const [confirmedConfigNum, setConfirmedConfigNum] = useState(0);
  const [inProgressConfigNum, setinProgressConfigNum] = useState(0);
  const [expiredConfigNum, setexpiredConfigNum] = useState(0);
  
  const [isNewProjectModalOpen, setIsNewProjectModalOpen] = useState(false);
  const [projectToEdit, setProjectToEdit] = useState(null);
  
  const [searchInput, setSearchInput] = useState(location.state?.searchValue || '');


/* ----------------------------------------------- */
  useEffect(() => { // fetch projects
    dispatch(fetchProjectsRequest());
    dispatch(fetchUsersRequest());
    if(user && user.groupId && (user.groupId == 1 || user.groupId == 2)) {
      dispatch(checkConfigurationsExpiredRequest())
    }
  }, [dispatch])

  useEffect(() => { // fetch projects
    setIsNewProjectModalOpen(false);
  }, [projects])


  useEffect(() => { // count projects and configurations
    const totalProjects = projects.length;
    const totalProjectsOpen = projects.filter(project => project.status === 'OPENED').length;
    const totalProjectsClose = projects.filter(project => project.status === 'CLOSED').length;
    const totalConfigs = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.length || 0), 0);
    const totalinProgress = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.filter(config => config.status === 'PENDING')?.length || 0), 0);
    const totalConfirmed = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.filter(config => config.status === 'QUOTE_OK')?.length || 0), 0);
    const totalinExpired = projects.reduce((acc, project) => acc + (project.ProjConfigurations?.filter(config => config.status === 'QUOTE_EXPIRED')?.length || 0), 0);
    
    setProjectsNum(totalProjects);
    setProjectsOpen(totalProjectsOpen);
    setProjectsClose(totalProjectsClose);
    setConfigsNum(totalConfigs);
    setConfirmedConfigNum(totalConfirmed);
    setinProgressConfigNum(totalinProgress);
    setexpiredConfigNum(totalinExpired);
  }, [projects]);


  useEffect(() => { // reset projectToEdit when modal is closed
    if(isNewProjectModalOpen) {
      setProjectToEdit(null);
    }
    
  }, [isNewProjectModalOpen])

  useEffect(() => { // count projects and configurations
    const customers = users.filter(user => user.groupId == 3); 
    
    setCustomersNum(customers.length);
  }, [users]);
/* ----------------------------------------------- */

  useEffect(() => {
    if (location.state?.searchValue) {
      setSearchInput(location.state.searchValue);
    }
  }, [location.state]);

  const SideBar = () => ( /* sub-component project (sidebar) */
      <div className="sidebar">
        <div className='profileContainer'>
          <div className='card pc-user-card'>
            <div className="card-body">
              <div className="d-flex align-items-center">
                <div className="profileImg">

                    {imgSrc ? <img src={imgSrc} alt="user-image" className="user-avatar rounded-circle" /> : <Loading  type={'large'}/>}

                </div>
                <div className="flex-grow-1 ms-1">
                  <span>{t('welcomeBack')} 👋</span>
                  <Link to={'/profile'}>
                    <h6 className="mb-0">{user?.fullName}</h6>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sidebarContent">
            <div className="card">
              <div className="card-body p-3">
                {(user.groupId == 1 || user.groupId == 2) && (
                  <div className="dataContainer">
                    <p className="dataTitle"> <i className="mdi mdi-account-group-outline" /> {t('customers')}</p>
                    <span className="infoData">{customersNum}</span>
                  </div>
                )}
                <div className="dataContainer">
                  <p className="dataTitle"> <i className="mdi mdi-file-document-multiple-outline" /> {t('myProjects')}</p>
                  <span className="infoData">{projectsNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-package-variant color-inProgress" /> {t('myProjectsOpen')}</p>
                  <span className="infoData">{projectsOpen}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-package-variant-closed color-expired" /> {t('myProjectsClosed')}</p>
                  <span className="infoData">{projectsClose}</span>
                </div>
                <hr />
                <div className="dataContainer">
                  <p className="dataTitle"> <i className="mdi mdi-file-cog-outline" /> {t('Configurations')}</p>
                  <span className="infoData">{configsNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-file-clock-outline color-inProgress" /> {t('PENDING')} </p>
                  <span className="infoData">{inProgressConfigNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-file-check-outline color-confirmed" /> {t('QUOTE_OK')} </p>
                  <span className="infoData">{confirmedConfigNum}</span>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-file-alert-outline color-expired" /> {t('EXPIRED')} </p>
                  <span className="infoData">{expiredConfigNum}</span>
                </div>
              </div>

            </div>

              <div className="card-body helpCard">

              <div className="dataContainer">
                <p className="dataTitle subTitle" onClick={() => window.open("https://www.cenco.fr/#catalogue-cenco-2024/1/", "_blank")}> <i className="mdi mdi-book-outline" /> <span className="helpLink">{t('ask')} {t('catalog')}</span> </p>
              </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle" onClick={() => window.open("https://www.cenco.fr/contact-et-acces/", "_blank")}> <i className="mdi mdi-file-document-edit-outline" /> <span className="helpLink">{t('ask')} {t('estimateAndInfo')} </span> </p>
              </div>

              </div>

            <div className="card-body contactCard">

                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-map-marker" /> 36 rue de l'Industrie,<br /> 01540 VONNAS </p>
                </div>
                <div className="dataContainer">
                  <p className="dataTitle subTitle"> <i className="mdi mdi-phone" /> 04 74 42 53 74 </p>
                </div>


            </div>
        </div>
      </div>
  )

  const handleEditProject = (projectId, projectLib, projectStatus) => {

    setProjectToEdit({id: projectId, lib: projectLib, status: projectStatus});
    setIsNewProjectModalOpen(true);

  }

  const handleCustomerFilterChange = (e, value) => {
    setCustomerFilter(e);
  }

  const ContentPage = () => ( /* sub-component project (content) */
    <>
      <Tuiles 
        projects={
          (searchInput !== '') 
            ? projects.filter(project => {
              // Filtre par recherche texte
              const matchesSearch = searchInput === '' || 
                project.lib.toLowerCase().includes(searchInput.toLowerCase());
              
              // Filtre par client sélectionné
              const matchesCustomer = customerFilter.length === 0 || 
                customerFilter.some(customer => customer.value === project.userId);
              
              return matchesSearch && matchesCustomer;
            }) 
            : projects.filter(project => {            
              // Filtre par client sélectionné
              const matchesCustomer = customerFilter.length === 0 || 
                customerFilter.some(customer => customer.value === project.userId);
              
              return matchesCustomer;
            })}
        editFunction={handleEditProject} 
        />
    </>
  )

  ErrorHandler(errorProject, clearProjectErrors);

  useEffect(() => {
    if (projectAdded) {
      toast.success(t('dataSaved'));
      dispatch(clearProjectSuccess());
    }
  }, [projectAdded]);

  return (
    <div className="page-content">
      <DashboardLayout sideBar={<SideBar />} containerClass="projectContainer">
        <Card className="w-100">
          <CardBody className="d-flex flex-column w-100 align-items-center h-100 p-0">
            <Row className="w-100 h-25 p-2 d-flex justify-content-between align-items-center newProjectBtnContainer">
              <Col xl={3} lg={4} md={12}>
                { (!customerFilter.length) ?
                  <h2>{t('myProjects')}</h2> :
                  <h2>{t('projects')}</h2>
                } 
              </Col>
              <Col xl={9} lg={8} md={12}>
                <div className="titleSearchContainer">
                  {(user.groupId == 1 || user.groupId == 2) &&
                    <Select
                      isMulti
                      className="filter"
                      name={"customerFilter"}
                      id={"customerFilter"}
                      options={users.map(option => {
                        return { value: option.id, label: t(option.fullName) }
                      })}
                      classNamePrefix="select"
                      value={customerFilter}
                      placeholder={t('customers')}
                      onChange={(e, value) => {
                        handleCustomerFilterChange(e, value);
                      }}
                    />
                  }
                  <form className="app-search d-none d-lg-block">
                    <div className="position-relative input">
                      <input
                        type="text"
                        className="form-control"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        placeholder={t("search")}
                      />
                      <span className="bx bx-search-alt" />
                    </div>
                  </form>
                  <button className="btn btn-primary newProjectBtn" onClick={() => setIsNewProjectModalOpen(true)}>
                    <i className='bx bx-plus bx-tada'></i> {t('newProject')}
                  </button>
                  <NewProjectModal isModalOpen={isNewProjectModalOpen} setModalOpen={setIsNewProjectModalOpen} projToEdit={projectToEdit}/>
                </div>
              </Col>
            </Row>
            <Row className="w-100 projectContent h-75 p-0">
              <ContentPage />
            </Row>
          </CardBody>
        </Card>
        <ToastContainer />
      </DashboardLayout>
    </div>
  )
}